import CloseIcon from '@mui/icons-material/Close'
import { Box, Dialog, DialogContent, DialogTitle, IconButton, useMediaQuery, useTheme } from '@mui/material'

import type { FormDataCustom, SupportRequestDialogProps } from '../types'
import SupportTicketModal from './SupportTicketModal'

const SupportRequestDialog = ({ open, onClose, onSubmit }: SupportRequestDialogProps) => {
  const handleFormSubmit = (data: FormDataCustom) => {
    onSubmit(data)
  }

  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" fullScreen={fullScreen} scroll="paper">
      <DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <SupportTicketModal onSubmit={handleFormSubmit} onClose={onClose} />
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default SupportRequestDialog
